import React from 'react';
import MetafieldDefinitionsPage from './MetafieldDefinitionsPage';

export default function CollectionMetafields() {
  return (
    <MetafieldDefinitionsPage
      ownerType="COLLECTION"
      title="Collection metafields"
      routePrefix="/metafields/collection"
    />
  );
}
